
import { NavigationExtras, Router } from '@angular/router';
import { AlertController, NavController, Platform } from '@ionic/angular';
import { Component } from '@angular/core';
import { EventService } from './services/event.service';
import { TranslateService } from '@ngx-translate/core';
import { App as CapacitorApp } from '@capacitor/app';
//import OneSignal from 'onesignal-cordova-plugin';
import OneSignal from '@onesignal/capacitor-plugin';
import { Location } from '@angular/common';
import { Api } from './services/api';
import { Device } from '@capacitor/device';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {

  public appPages = [
    { title: 'Dealr Solutions', url: '/folder/Inbox', icon: 'mail' },
    { title: 'Car Loan', url: '/folder/Outbox', icon: 'paper-plane' },
    { title: 'EMI Calculator', url: '/folder/Favorites', icon: 'heart' },
    { title: 'Car Insurance', url: '/folder/Archived', icon: 'archive' },
  ];

  public labels = ['Dealr Solutions', 'Car Loan', 'EMI Calculator', 'Car Insurance'];
  logininfo: any;
  desid: any;
  uuid: any = null;
  private notificationAlertOpen = false;
  constructor(private router: Router, public events: EventService, private translate: TranslateService, private platform: Platform, private alertController: AlertController, private _location: Location, public masterapi: Api) {
    this.events.getObservable().subscribe((data) => {
      console.log("Data received:", data);
      if (data.isLogin == true) {
        const logindata = localStorage.getItem('logininfo');
        this.logininfo = logindata ? JSON.parse(logindata) : null;
        this.desid = this.logininfo?.designation


      }


    })
    this.initializeApp();
    let lang = localStorage.getItem('language');
    debugger

    this.translate.setDefaultLang(lang && lang != 'null' ? lang : 'en');
    this.platform.backButton.subscribeWithPriority(9999, () => {
      console.log('Handler was called!--22');
      let page = this.platform.url().split("/").pop()
      // alert(page)
      debugger

      if (page == 'home' || page == 'login') {
        // CapacitorApp.exitApp();
        this.showConfirmationDialog().then((confirmed) => {
          if (confirmed) {
            CapacitorApp.exitApp();
          }
        })
      } else {
        //alert('Back button pressed!');
        this._location.back();
      }



    });
  }

  checkpermission(name: string): boolean {
    const logindata = localStorage.getItem('logininfo');
    this.logininfo = logindata ? JSON.parse(logindata) : null;
    const rights = Array.isArray(this.logininfo?.rights) ? this.logininfo.rights : [];

    if (rights.length > 0) {
      const foundItem = rights.find((item: any) => item.module === name);
      if (foundItem) {
        return foundItem.isDisplay ? true : false;
      }
    }

    return false;
  }
  async showConfirmationDialog(): Promise<boolean> {

    return new Promise<boolean>((resolve) => {
      this.alertController
        .create({
          header: 'Confirmation',
          message: 'Are you sure you want to close the app?',
          buttons: [
            {
              text: 'Cancel',
              role: 'cancel',
              handler: () => {

                resolve(false); // User chose to cancel closing the app
              },
            },
            {
              text: 'Close',
              handler: () => {
                resolve(true); // User confirmed closing the app
              },
            },
          ],
        })
        .then((alert) => {
          alert.present();
        });
    });
  }
  initializeApp() {
    ;
    this.platform.ready().then(() => {
      if (this.platform.is('hybrid')) {
        this.OneSignalInit()
        // this.getplayerid()

        // re-check permission whenever the app comes back to the foreground, e.g.
        // after the user returns from the device Settings app
        CapacitorApp.addListener('appStateChange', ({ isActive }) => {
          if (isActive) {
            this.ensureNotificationPermission();
          }
        });
      }
    });
  }

  // keeps prompting until the user grants notification permission; falls back to
  // opening the device Settings screen once the OS will no longer show the native prompt
  async ensureNotificationPermission(): Promise<void> {
    const hasPermission = await OneSignal.Notifications.hasPermission();
    if (hasPermission || this.notificationAlertOpen) {
      return;
    }

    const canRequest = await OneSignal.Notifications.canRequestPermission();

    this.notificationAlertOpen = true;
    await this.showPermissionRequiredAlert(!canRequest);
    this.notificationAlertOpen = false;
  }

  showPermissionRequiredAlert(openSettings: boolean): Promise<void> {
    return new Promise<void>((resolve) => {
      this.alertController
        .create({
          header: 'Notification Permission Required',
          message: openSettings
            ? 'Notifications are currently disabled. Please enable them from Settings to continue using the app.'
            : 'This app requires notification permission to send you important updates. Please allow notifications to continue.',
          backdropDismiss: false,
          buttons: [
            {
              text: openSettings ? 'Open Settings' : 'Allow',
              handler: () => {
                OneSignal.Notifications.requestPermission(true);
                resolve();
              },
            },
          ],
        })
        .then((alert) => alert.present());
    });
  }

  async OneSignalInit() {
    await OneSignal.initialize(
      '5f98c977-33f2-4d7a-932f-4f7fd265890f'
    );

    // fires whenever the subscription id/token becomes available or changes (covers the
    // first-launch case where the id isn't ready yet right after requestPermission)
    OneSignal.User.pushSubscription.addEventListener('change', (event) => {
      const newId = event?.current?.id;
      console.log('SUBSCRIPTION CHANGED:', newId);
      if (newId) {
        this.insertuuid(newId);
      }
    });

    await this.ensureNotificationPermission();

    const subscriptionId = await this.getSubscriptionIdWithRetry();

    console.log('CURRENT SUBSCRIPTION ID:', subscriptionId);

    const token =
      await OneSignal.User.pushSubscription.getTokenAsync();

    console.log('PUSH TOKEN:', token);

    const optedIn =
      await OneSignal.User.pushSubscription.getOptedInAsync();

    console.log('OPTED IN:', optedIn);

    if (subscriptionId) {
     // alert('OneSignal Player ID: ' + subscriptionId);
      Device.getId().then((id) => {
        console.log("identifier ", id.identifier);
        this.uuid = id.identifier

      })
      Device.getInfo().then((data) => {
        console.log("androidSDKVersion ", data.androidSDKVersion);
        console.log("model ", data.model);
        console.log("osVersion ", data.osVersion);
        console.log("platform ", data.platform);
        let val = {
          "androidSDKVersion": data.androidSDKVersion,
          "model": data.model,
          "osVersion": data.osVersion,
          "platform": data.platform,
          "onesignal_player_id": subscriptionId
        }
        this.insertuuid(val)
      })
      //  this.insertuuid(subscriptionId);
    }
  }

  // getIdAsync() can return empty on first launch before the SDK finishes registering,
  // so poll a few times before giving up (the 'change' listener will still catch it later)
  async getSubscriptionIdWithRetry(maxAttempts = 5, delayMs = 1000): Promise<string | undefined> {
    for (let attempt = 1; attempt <= maxAttempts; attempt++) {
      const id = await OneSignal.User.pushSubscription.getIdAsync();
      if (id) {
        return id;
      }
      await new Promise((resolve) => setTimeout(resolve, delayMs));
    }
    return undefined;
  }

  //   OneSignalInit1() {

  //     // Uncomment to set OneSignal device logging to VERBOSE  
  //     // OneSignal.setLogLevel(6, 0);
  //     debugger
  //     let playerId;
  //     // NOTE: Update the setAppId value below with your OneSignal AppId.
  //     OneSignal.setAppId("5f98c977-33f2-4d7a-932f-4f7fd265890f");

  //     OneSignal.promptForPushNotificationsWithUserResponse((accepted) => {
  //       console.log('User accepted notifications:', accepted);

  //       OneSignal.getDeviceState((data) => {
  //         playerId = data.userId;
  //         //alert('OneSignal Player ID: ' + playerId);
  //         console.log('OneSignal Player ID:', playerId);
  //         this.insertuuid(data);
  //       });
  //     });

  // OneSignal.promptForPushNotificationsWithUserResponse((accepted) => {

  //   console.log('Notification permission:', accepted);

  //   OneSignal.getDeviceState((data) => {

  //     console.log('========== ONESIGNAL DEVICE STATE ==========');
  //     console.log('userId:', data.userId);
  //     console.log('pushToken:', data.pushToken);
  //     console.log('subscribed:', data.subscribed);
  //     console.log('hasNotificationPermission:', data.hasNotificationPermission);
  //     console.log('FULL DATA:', data);
  //     console.log('============================================');

  //     this.insertuuid(data);
  //   });

  // });

  // OneSignal.setNotificationOpenedHandler(function (jsonData) {
  //   debugger
  //   console.log('jsonData info=>', jsonData);
  //   this.oneSignal.getIds().then((data) => {
  //     playerId = data.userId;
  //     console.log('OneSignal Player ID:', playerId);
  //     console.log('user info=>', data);
  //     this.insertuuid(data)
  //   })
  //   console.log('notificationOpenedCallback: ' + JSON.stringify(jsonData));
  // });

  // Prompts the user for notification permissions.
  //    * Since this shows a generic native prompt, we recommend instead using an In-App Message to prompt for notification permission (See step 7) to better communicate to your users what notifications they will get.
  // OneSignal.promptForPushNotificationsWithUserResponse(function (accepted) {
  //   console.log("User accepted notifications: " + accepted);
  //   this.oneSignal.getIds().then((data) => {
  //     console.log('user info=>', data);
  //   })
  //   debugger
  // });



  //}
  // getplayerid() {
  //   var appId = '5f98c977-33f2-4d7a-932f-4f7fd265890f';
  //   var restApiKey = 'NGNlYjc3ZGQtYmI2ZS00NjFkLTg1YzYtNTJjMmU0YTIzMDI0';
  //   var deviceId = 'c2cd2341d86299ee';
  //   fetch(`https://onesignal.com/api/v1/players?app_id=${appId}&identifier=${deviceId}`, {
  //     method: 'GET',
  //     headers: {
  //       'Content-Type': 'application/json',
  //       'Authorization': `Basic ${restApiKey}`
  //     }
  //   })
  //     .then(response => response.json())
  //     .then(data => {
  //       if (data.players.length > 0) {
  //         var playerId = data.players[0].id;
  //        // alert(playerId);
  //         console.log('Player ID:', playerId);
  //       } else {
  //         console.log('Player ID not found for the device ID:', deviceId);
  //       }
  //     })
  //     .catch(error => {
  //       console.error('Error:', error);
  //     });
  // }



  // goToNewCars(val) {
  //   const navData: NavigationExtras = {
  //     queryParams: {
  //       id: JSON.stringify(val)
  //     }
  //   };
  //   this.router.navigate(['/new-cars'], navData);
  // }



  goToTest() {
    this.router.navigate(['/test']);
  }

  insertuuid(val: any) {
  console.log('insert_update_device_id app component', val);
    let data =
    {
      'isPlayerId': true,
      'onesignal_player_id': val?.onesignal_player_id ? val.onesignal_player_id : '',
      "device_id": this.uuid,
      'androidSDKVersion': val?.androidSDKVersion,
      'model': val?.model,
      'osVersion': val?.osVersion,
      'platform': val?.platform,
      //'onesignal_player_id': null,
      //'isPlayerId': false,
    }

    if (val?.onesignal_player_id) {
      this.masterapi.post('insert_update_device_id', data).subscribe(
        async (resp) => {
          console.log('insert_update_device_id app component', resp);

          if (resp) {
            //  this.topsearchdata = resp['data']
            //hotels_result
            //locality_master_result 


            //this.dismissLoader()
          }
        },
        // async (err) => {
        //   const toast = await this.toastCtrl.create({
        //     message: "Please try again later",
        //     duration: 2000,
        //     cssClass: 'toast-background-error'
        //   });
        //   toast.present();
        //   // this.dismissLoader()
        // }
      );
    }

  }

  //
  goToPage(url: string) {
    this.router.navigate([url]);
  }

  Logout() {
    localStorage.clear();
    let lang = localStorage.getItem('language') || "";

    localStorage.setItem('language', lang);
    this.router.navigate(['/login']);
  }


}
